var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleThrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22290_32577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "#DC2626",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.5 0.5C37.65 0.5 48.352 11.132 48.488 24.25C48.488 24.166 48.5 24.084 48.5 24C48.5 10.766 37.734 0 24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 24.084 0.512 24.166 0.512 24.25C0.648 11.132 11.352 0.5 24.5 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M24.5 47.5C11.35 47.5 0.648 36.868 0.512 23.75C0.512 23.834 0.5 23.916 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 23.916 48.488 23.834 48.488 23.75C48.352 36.868 37.648 47.5 24.5 47.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3333 21.5001L29.7367 29.2557C29.6032 30.9924 28.155 32.3334 26.4132 32.3334H22.5868C20.845 32.3334 19.3968 30.9924 19.2633 29.2557L18.6667 21.5001M32 19.8334C29.8351 18.7784 27.2614 18.1667 24.5 18.1667C21.7386 18.1667 19.1649 18.7784 17 19.8334M22.8333 18.1667V17.3334C22.8333 16.4129 23.5795 15.6667 24.5 15.6667C25.4205 15.6667 26.1667 16.4129 26.1667 17.3334V18.1667M22.8333 23.1667V28.1667M26.1667 23.1667V28.1667",
    stroke: "#EF4444",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0C11.266 0 0.5 10.766 0.5 24C0.5 37.234 11.266 48 24.5 48C37.734 48 48.5 37.234 48.5 24C48.5 10.766 37.734 0 24.5 0Z",
    fill: "url(#paint0_linear_22290_32577)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22290_32577",
    x1: 2.75,
    y1: 13.858,
    x2: 46.25,
    y2: 34.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22290_32577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleThrash);
export default __webpack_public_path__ + "static/media/circle-thrash.fa25d424.svg";
export { ForwardRef as ReactComponent };